import React, { Component } from "react";
import { isEqual } from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import GranteeOrganizationContact from "../../Components/GranteeOrganizationContact/GranteeOrganizationContact";
import GrantPurpose from "../../../RecommendGrant/Component/GrantPurpose/GrantPurpose";
import GrantRecognition from "../../../RecommendGrant/Component/GrantRecognition/GrantRecognition";
import PermissionToPublish from "../../../RecommendGrant/Component/PermissionToPublish/PermissionToPublish";
import FlowFooter from "../../../RecommendGrant/Component/FlowFooter/FlowFooter";
import { saveStepOneDataInReducer, editSet, newAgreement, backReset } from "../../actions";
import { GrantsDivider, SectionMediumDivider } from "../../styles";
import grantPurposeDropdown from "./grantPurposeDropdown";
import { moveIntoErrorPosition } from "../../../../../../utils/commonUtil";
import { contactPurposeDerivedStates } from '../../Selectors/ContactPurposeSelectors';

export class ContactPurposeRecognition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      granteeOrgFirstName: this.props.firstName || "",
      granteeOrgLastName: this.props.lastName || "",
      granteeOrgEmailAddr: this.props.email || "",
      granteeOrgPhoneNumber: this.props.phone || "",
      grantPurposeId: this.props.grantPurposeId || "",
      grantRecognition: {
        accountName: this.props.accountName || "",
        grantRecognition: this.props.recognition || "",
        inHonorOfName: this.props.inHonorOfName || "",
        inMemoryOfName: this.props.inMemoryOfName || "",
        includeAdvisorInfo: this.props.includeAdvisorInfo || false,
        notifyFirstName: this.props.notifyFirstName || "",
        notifyLastName: this.props.notifyLastName || "",
        thirdParty: this.props.thirdParty || ""
      },
      purpose: {
        description: this.props.grantPurposeDropdown || "",
        additionalComments: this.props.grantPurposeComments || "",
        purposeCertification: this.props.purposeCertification || false
      },
      purposeFormValid: false,
      contactFormValid: false,
      recognitionFormValid: false,
      permissionToPublish: false,
      individualValidator: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  storeGranteeOrgContact = ({ data, isFormValid }) => {
    this.setState({
      granteeOrgFirstName: data.granteeOrgFirstName,
      granteeOrgLastName: data.granteeOrgLastName,
      granteeOrgEmailAddr: data.granteeOrgEmailAddr,
      granteeOrgPhoneNumber: data.granteeOrgPhoneNumber,
      contactFormValid: isFormValid
    });
  };

  formEqual = () => {
    const stateVal = {
      granteeOrgFirstName: this.state.granteeOrgFirstName,
      granteeOrgLastName: this.state.granteeOrgLastName,
      granteeOrgEmailAddr: this.state.granteeOrgEmailAddr,
      granteeOrgPhoneNumber: this.state.granteeOrgPhoneNumber,
      grantPurposeId: this.state.grantPurposeId,
      accountName: this.state.grantRecognition.accountName,
      grantRecognition: this.state.grantRecognition.grantRecognition,
      inHonorOfName: this.state.grantRecognition.inHonorOfName,
      inMemoryOfName: this.state.grantRecognition.inMemoryOfName,
      includeAdvisorInfo: this.state.grantRecognition.includeAdvisorInfo,
      notifyFirstName: this.state.grantRecognition.notifyFirstName,
      notifyLastName: this.state.grantRecognition.notifyLastName,
      thirdParty: this.state.grantRecognition.thirdParty,
      description: this.state.purpose.description,
      additionalComments: this.state.purpose.additionalComments,
      purposeCertification: this.state.purpose.purposeCertification,
      permissionToPublish: this.state.permissionToPublish
    }

    const propsVal = {
      granteeOrgFirstName: this.props.firstName,
      granteeOrgLastName: this.props.lastName,
      granteeOrgEmailAddr: this.props.email,
      granteeOrgPhoneNumber: this.props.phone,
      grantPurposeId: this.props.grantPurposeId,
      accountName: this.props.accountName,
      grantRecognition: this.props.recognition,
      inHonorOfName: this.props.inHonorOfName,
      inMemoryOfName: this.props.inMemoryOfName,
      includeAdvisorInfo: this.props.includeAdvisorInfo,
      notifyFirstName: this.props.notifyFirstName,
      notifyLastName: this.props.notifyLastName,
      thirdParty: this.props.thirdParty,
      description: this.props.grantPurposeDropdown,
      additionalComments: this.props.grantPurposeComments,
      purposeCertification: this.props.purposeCertification,
      permissionToPublish: this.props.permissionToPublish
    }
    return !isEqual(stateVal, propsVal);
  }

  storePurposeChange = ({ data, isFormValid }) => {
    const {
      purposeName,
      additionalComments,
      purposeId,
      purposeCertification
    } = data;
    const purpose = {
      description: purposeName,
      additionalComments,
      purposeCertification
    };
    this.setState(prevState => ({
      purpose,
      grantPurposeId: purposeId,
      purposeFormValid: isFormValid
    }));
  };

  storePermissionToPublish = ({ data }) => {
    this.setState(prevState => ({
      permissionToPublish: !data.publishName
    }));
  };

  isEnabled = () =>
    this.state.contactFormValid &&
    this.state.purposeFormValid &&
    this.state.recognitionFormValid;

  storeRecognition = ({ data, isFormValid }) => {
    this.setState(prevState => ({
      grantRecognition: { ...prevState.grantRecognition, ...data },
      recognitionFormValid: isFormValid
    }));
  };

  submitData = () => {
    this.props.saveStepOneDataInReducer(this.state);
  };

  handleSubmit = type => {
    this.setState({ individualValidator: !this.state.individualValidator });

    if (this.isEnabled()) {
      const { history } = this.props;
      this.submitData();
      history.push("/grants/grant-agreement/allocation-schedule");
    } else {
      setTimeout(() => {
        moveIntoErrorPosition(".error-fields");
      });
    }
  };

  handleUpdate = () => {
    this.setState({ individualValidator: !this.state.individualValidator });

    if (this.isEnabled()) {
      this.submitData();
      this.props.onUpdate();
    } else {
      setTimeout(() => {
        moveIntoErrorPosition(".error-fields");
      });
    }
  };

  handleExit = () => {
    this.props.newAgreement();
    this.props.history.push("/");
  };

  handleBack = () => {
    this.props.backReset();
    this.props.history.push("/grants/grant-agreement");
  };

  getPropsDataForUpdateChecking = () => {
    const {
      inHonorOfName,
      inMemoryOfName,
      notifyFirstName,
      notifyLastName,
      thirdParty,
      includeAdvisorInfo,
      permissionToPublish,
      grantPurposeDropdown,
      grantPurposeId,
      grantPurposeComments,
      firstName,
      lastName,
      phone,
      email,
      recognition,
      accountName,
      purposeCertification
    } = this.props;

    return {
      inHonorOfName,
      inMemoryOfName,
      notifyFirstName,
      notifyLastName,
      thirdParty,
      includeAdvisorInfo,
      permissionToPublish,
      description: grantPurposeDropdown,
      grantPurposeId,
      additionalComments: grantPurposeComments,
      purposeCertification,
      granteeOrgFirstName: firstName,
      granteeOrgLastName: lastName,
      granteeOrgPhoneNumber: phone,
      grantRecognition: recognition,
      granteeOrgEmailAddr: email,
      accountName
    };
  };

  getStateDataForUpdateChecking = () => {
    const {
      granteeOrgFirstName,
      granteeOrgLastName,
      granteeOrgEmailAddr,
      granteeOrgPhoneNumber,
      grantPurposeId,
      grantRecognition,
      purpose,
      permissionToPublish
    } = this.state;

    const {
      inHonorOfName,
      inMemoryOfName,
      notifyFirstName,
      notifyLastName,
      thirdParty,
      includeAdvisorInfo,
      accountName
    } = grantRecognition;

    return {
      inHonorOfName,
      inMemoryOfName,
      notifyFirstName,
      notifyLastName,
      thirdParty,
      includeAdvisorInfo,
      permissionToPublish,
      description: purpose.description,
      grantPurposeId,
      additionalComments: purpose.additionalComments,
      purposeCertification: purpose.purposeCertification,
      granteeOrgFirstName,
      granteeOrgLastName,
      granteeOrgPhoneNumber,
      grantRecognition: grantRecognition.grantRecognition,
      granteeOrgEmailAddr,
      accountName
    };
  };

  render() {
    const isDisabled = this.isEnabled();
    const {
      editMode,
      history,
      grantPurposeComments,
      purposeCertification,
      permissionToPublish,
      enableCancelPopUp
    } = this.props;
    const {
      granteeOrgFirstName,
      granteeOrgLastName,
      granteeOrgEmailAddr,
      granteeOrgPhoneNumber,
      grantPurposeId,
      individualValidator
    } = this.state;
    const {
      grantRecognition,
      inHonorOfName,
      inMemoryOfName,
      notifyFirstName,
      notifyLastName,
      thirdParty,
      includeAdvisorInfo
    } = this.state.grantRecognition;
    return (
      <>
        <GranteeOrganizationContact
          granteeOrgFirstName={granteeOrgFirstName}
          granteeOrgLastName={granteeOrgLastName}
          granteeOrgEmailAddr={granteeOrgEmailAddr}
          granteeOrgPhoneNumber={granteeOrgPhoneNumber}
          storeContactData={this.storeGranteeOrgContact}
          individualValidator={individualValidator}
        />
        <GrantsDivider />
        <GrantPurpose
          addtnlComments={grantPurposeComments}
          grantPurposeData={grantPurposeDropdown()}
          grantPurposeId={grantPurposeId}
          handleFormChange={this.storePurposeChange.bind(this)}
          purposeCertification={purposeCertification}
          selectedPurposeName={this.props.grantPurposeName}
          individualValidator={individualValidator}
          grantAgreementFlag={true}
          isPurposeCheckNotShow={true}
          purposeText="Please indicate the purpose of this grant along with any additional comments you would like to provide."
        />
        <GrantsDivider />
        <GrantRecognition
          recognitionOption={grantRecognition}
          honorOf={inHonorOfName}
          memoryOf={inMemoryOfName}
          firstName={notifyFirstName}
          lastName={notifyLastName}
          comments={thirdParty}
          handleFormChange={this.storeRecognition}
          individualValidator={individualValidator}
          includeAdvisorInfo={!includeAdvisorInfo}
          recognitionText="Choose which information you'd like us to share with the grantee organization."
        />

        {grantRecognition !== "30" && (
          <div>
            <GrantsDivider />
            <PermissionToPublish
              handleFormChange={this.storePermissionToPublish}
              publishCheck={permissionToPublish}
              page={"Grant Agreement"}
              isGaw={true}
            />
          </div>
        )}
        <GrantsDivider marginTop="10px" marginBottom="38px" />

        <FlowFooter
          edit={editMode}
          page={'Grant Agreement'}
          handleSecondaryCta={this.handleBack}
          handleExitCta={this.handleExit}
          handlePrimaryCta={this.handleSubmit}
          enableCancelPopUp={enableCancelPopUp && this.formEqual()}
          keyProperty={"Exit Grant Agreement"}
          keyPropertyUpdate={"Cancel Grant Agreement"}
          handleUpdateCancel={() =>
            history.push("/grants/grant-agreement/review")
          }
          handleUpdateCta={this.handleUpdate}
        />
      </>
    );
  }
}

ContactPurposeRecognition.propTypes = {
  accountName: PropTypes.string,
  backReset: PropTypes.func,
  editMode: PropTypes.bool,
  email: PropTypes.string,
  enableCancelPopUp: PropTypes.bool,
  firstName: PropTypes.string,
  grantPurposeComments: PropTypes.string,
  grantPurposeDropdown: PropTypes.string,
  grantPurposeId: PropTypes.string,
  grantPurposeName: PropTypes.string,
  inHonorOfName: PropTypes.string,
  inMemoryOfName: PropTypes.string,
  includeAdvisorInfo: PropTypes.bool,
  lastName: PropTypes.string,
  notifyFirstName: PropTypes.string,
  notifyLastName: PropTypes.string,
  onUpdate: PropTypes.func,
  permissionToPublish: PropTypes.bool,
  phone: PropTypes.string,
  purposeCertification: PropTypes.bool,
  recognition: PropTypes.string,
  saveStepOneDataInReducer: PropTypes.func,
  thirdParty: PropTypes.string,
  editSet: PropTypes.func,
  newAgreement: PropTypes.func,
}
const mapStateToProps = state => ({
  ...contactPurposeDerivedStates(state.toJS())
});

const mapDispatchToProps = dispatch => ({
  saveStepOneDataInReducer: data => dispatch(saveStepOneDataInReducer(data)),
  editSet: bool => dispatch(editSet(bool)),
  newAgreement: data => dispatch(newAgreement(data)),
  backReset: data => dispatch(backReset(data))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContactPurposeRecognition)
);
